@for (changeSet of orderHistory.changeSets; track changeSet; let isLatestOrderChange = $first) {
	<order-changes [changeSet]="changeSet" [latestOrderChanges]="isLatestOrderChange" [showDailyRate]="showDailyRate" [includeOffsiteDays]="includeOffsiteDays" [isLead]="isLead(changeSet)"
				   [billingInfoVisible]="billingInfoVisible"></order-changes>
}
